import { render } from "./NoPosts.vue?vue&type=template&id=1db46cba&scoped=true"
import script from "./NoPosts.vue?vue&type=script&lang=js"
export * from "./NoPosts.vue?vue&type=script&lang=js"

import "./NoPosts.vue?vue&type=style&index=0&id=1db46cba&lang=scss&scoped=true"

import exportComponent from "/Users/skynet/Documents/Sites safe 2026/Safe_Sites_Modifs/SAFE_GROUP/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db46cba"]])

export default __exports__